import React from 'react';
import { useSelector } from 'react-redux';

import BirthInformation from '~app/components/BirthInformation';
import SimulationLoadingWrapper from '~app/components/SimulationLoadingWrapper';
import { INCUMBENT_TYPES } from '~constants/incumbent';
import { ROUTES } from '~constants/routes';
import { STEPS_TARGETS } from '~constants/steps';
import { SIMULATION_TARGETS } from '~redux/Simulation/constants';

function GuarantorBirthInformation() {
  const { currentGuarantor, loanDraftLoading } = useSelector(state => state.simulation);
  return (
    <SimulationLoadingWrapper loading={loanDraftLoading}>
      <BirthInformation
        loading={loanDraftLoading}
        incumbent={INCUMBENT_TYPES.GUARANTOR}
        currentInfo={currentGuarantor}
        currentTarget={SIMULATION_TARGETS.CURRENT_GUARANTOR}
        nextStep={ROUTES.GUARANTOR_LABOR_INFORMATION.stepName}
        stepTarget={STEPS_TARGETS.GUARANTOR_BIRTH_INFORMATION}
      />
    </SimulationLoadingWrapper>
  );
}

export default GuarantorBirthInformation;
